import { replaceUrlProtocol } from "@/utils/filters";
import _cloneDeep from "lodash/cloneDeep";
import moment from "moment";

const state = {
    isPlaying: false,
    rate: "1.0",
    forward: 0,
    rewind: 0,
    currentAudioProgress: 0,
    audioSources: [],
    selectedAudioSource: 0,
    bookInsight: {},
    currentAudioState: {},
    rates: ["1.0", "1.5", "1.75", "2.0", "2.5", "3.0"],
    startTime: null,
    elapsedDuration: 0
}

const mutations = {
    SET_PLAYING(state, isPlaying) {
        state.isPlaying = isPlaying;
        if (isPlaying) {
            state.startTime = moment();
        }
    },
    SET_RATE(state, rate) {
        state.rate = rate;
    },
    SET_FORWARD(state) {
        state.forward = state.forward + 1;
    },
    SET_REWIND(state) {
        state.rewind = state.rewind + 1;
    },
    SET_AUDIO_SOURCES(state, audioSources = []) {
        state.audioSources = audioSources;
    },
    SET_BOOKINSIGHT(state, bookInsight) {
        state.bookInsight = bookInsight;
    },
    SET_SELECTED_AUDIO_SOURCE(state, index) {
        state.currentAudioState.progress = state.audioSources[index].progress;
        // on change always keep playing
        state.currentAudioState.isPlaying = true; //state.isPlaying;

        state.isPlaying = false;
        state.selectedAudioSource = index;
    },
    CLEAN_UP_DATA(state) {
        state.rate = "1.0";
        state.forward = 0;
        state.rewind = 0;
        state.isPlaying = false;
        state.currentAudioProgress = 0;
        state.audioSources = [];
        state.selectedAudioSource = 0;
        state.currentAudioState = {};
        state.bookInsight = {};
    },
    SET_SELECTED_AUDIO_SOURCE_DURATION(state, duration) {
        state.audioSources[state.selectedAudioSource].duration = duration;
    },
    SET_SELECTED_AUDIO_SOURCE_PROGRESS(state, progress) {
        state.audioSources[state.selectedAudioSource].progress = progress;
    },
    RESTORE_CURRENT_AUDIO_STATE(state) {
        let progress = 0;
        if (state.currentAudioState.progress >= 2) {
            progress = (state.currentAudioState.progress - 1) / 100;
        }
        state.currentAudioProgress = progress;
    },
    SET_ELAPSED_TIME(state, elapsedDuration) {
        state.elapsedDuration = elapsedDuration;
    },
    SET_START_TIME(state, startTime) {
        state.startTime = startTime;
    }
};

const actions = {
    toggle({ commit, state }) {
        commit("SET_PLAYING", !state.isPlaying);
    },
    setPlaying({ commit }, isPlaying) {
        commit("SET_PLAYING", isPlaying);
    },
    setRate({ commit }, rate) {
        commit("SET_RATE", rate);
    },
    setForward({ commit }) {
        commit("SET_FORWARD");
    },
    setRewind({ commit }) {
        commit("SET_REWIND");
    },
    formatSources({ dispatch }, themes = []) {
        const sources = _cloneDeep(themes);
        sources.map((item) => {
            item.hasAttachments = false;
            item.progress = 0 ;
            item.duration = 0 ;
            item.seek = 0 ;
            if (item.audio_url) {
                item.audioSrc = [replaceUrlProtocol(item.audio_url)];
                item.hasAudio = true;
            }
            return item;
        });
        dispatch("setAudioSources", _cloneDeep(sources.filter(item => item.hasAudio)));
    },
    setAudioSources({ commit }, audioSources) {
        commit("SET_AUDIO_SOURCES", audioSources);
    },
    setSelectedAudioSource({ commit }, index = 0) {
        commit("SET_SELECTED_AUDIO_SOURCE", index);
    },
    setBookInsight({ commit }, bookInsight = {}) {
        commit("SET_BOOKINSIGHT", _cloneDeep(bookInsight));
    },
    setSelectedAudioSourceProgress({ commit }, progress = 0) {
        commit("SET_SELECTED_AUDIO_SOURCE_PROGRESS", progress);
    },
    setSelectedAudioSourceDuration({ commit }, progress = 0) {
        commit("SET_SELECTED_AUDIO_SOURCE_DURATION", progress);
    },
    async restoreCurrentAudioState({ commit, state }) {
        await commit("RESTORE_CURRENT_AUDIO_STATE");
        commit("SET_PLAYING", state.currentAudioState.isPlaying);
    },
    cleanUpData({ commit }) {
        commit("CLEAN_UP_DATA");
    },
    calculateTotalElapsedDuration({ state }) {
        return moment.duration(moment().diff(state.startTime)).asSeconds();
    },
    async updateTotalElapsedTimeDuration({ commit, dispatch }) {
        const elapsedDuration = await dispatch("calculateTotalElapsedDuration");
        commit("SET_ELAPSED_TIME", elapsedDuration);
        dispatch("resetStartTime");
    },
    resetSelectedAudioState({ dispatch }) {
        dispatch("setPlaying", false);
        dispatch("setSelectedAudioSourceProgress", 0);
    },
    resetTotalElapsedTimeDuration({ commit }) {
        commit("SET_ELAPSED_TIME", 0);
    },
    resetStartTime({ commit }) {
        commit("SET_START_TIME", moment());
    }
};

const getters = {
    currentAudioSource(state) {
        return state.audioSources[state.selectedAudioSource];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
